module.exports = __webpack_public_path__ + "img/product_78.08a7039.webp";